import React from 'react';
import { useField } from 'formik';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

export const EditYesNo = ({ label, ...props }) => {
  const [field, meta] = useField(props);

  return (
    <TextField
      required
      fullWidth
      select
      variant="outlined"
      label={label}
      helperText={meta.touched && meta.error}
      error={meta.touched && !!meta.error}
      {...field}
      {...props}
    >
      <MenuItem value={true}>Yes</MenuItem>
      <MenuItem value={false}>No</MenuItem>
    </TextField>
  );
};
